export default {
  version: 'IDCLOUD-2798-platform-clear-filters-translations',
  compilation: '273845'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1475
// module chunks = 22